import { tg } from '@infotech-soe/metaschema';
import { IntlFormatters } from 'react-intl';

const numberToTimeString = (
  format: IntlFormatters['formatTime'],
  value: number,
  step?: number
): string =>
  format(value, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: tg.isSomething(step) && step < 1 ? '2-digit' : undefined,
    timeZone: 'utc',
  });

export default numberToTimeString;
